/**
 * @file 新手指南数据
 * @author FengGuang(fengguang01@baidu.com)
 */

export interface IGuidesItem {
    title: string;
    text: string;
    img: string;
    link: string;
    tagText: string;
}

const guidesData: IGuidesItem[] = [
    {
        title: '零基础',
        text: '为没有深度学习技术基础的开发者提供系统的新手课程，带您从零开始体验飞桨开发之旅',
        img: '',
        link: '/learningmaterials',
        tagText: '查看学习资源'
    },
    {
        title: '初学者',
        text: '如果您已经掌握了深度学习技术的基础知识，期望可以通过建立模型解决实际业务问题，建议您可以尝试了解 Paddle Fluid 的使用细节',
        img: '',
        link: '/documentation/docs/zh/user_guides/index_cn.html',
        tagText: '查看使用指南'
    },
    {
        title: '专家',
        text: '如果您已经熟悉Paddle Fluid，期望获得更高效的模型或者定义自己的Operator，可以尝试了解 Paddle Fluid 底层的设计思想，从而更好地理解框架运作过程',
        img: '',
        link: '/documentation/docs/zh/advanced_usage/index_cn.html',
        tagText: '查看进阶指南'
    }
];

export default guidesData;
